import { Payer } from './payer.model';
export class PaymentData {
    clientName: string;
    clientLastName: string;
    clientPhone: string;
    clientEmail: string;
    clientReEmail: string;
    subscribe: boolean;
    payer: Payer;
    paymentDTO: PaymentDTO;
    transactionUtmDTO: any;
    travellerLastName: string;
    travellerName: string;

    constructor(form: any, sameData?: boolean) {
        if (sameData) {
            this.clientName = form.get("payerData").get("payerName").value;
            this.clientLastName = form.get("payerData").get("payerLastName").value;
            this.clientEmail = form.get("payerData").get("emails").get("email").value;
            this.clientReEmail = form.get("payerData").get("emails").get("confirmEmail").value;
            this.travellerLastName = form.get("payerData").get("payerLastName").value;
            this.travellerName = form.get("payerData").get("payerName").value;
        } else {
            this.clientName = form.get("payerData").get("travellerName").value;
            this.clientLastName = form.get("payerData").get("travellerLastName").value;
            this.clientEmail = form.get("payerData").get("travellerEmails").get("email").value;
            this.clientReEmail = form.get("payerData").get("travellerEmails").get("confirmEmail").value;
            this.travellerLastName = form.get("payerData").get("travellerLastName").value;
            this.travellerName = form.get("payerData").get("travellerName").value;
        }
        this.subscribe = form.get("paymentSummary").get("subscribe").value;

        this.payer = new Payer;
        this.payer.name = form.get("payerData").get("payerName").value;
        this.payer.lastName = form.get("payerData").get("payerLastName").value;
        this.payer.email = form.get("payerData").get("emails").get("email").value;
        this.payer.reEmail = form.get("payerData").get("emails").get("confirmEmail").value;
        this.payer.country = form.get("payerData").get("payerCountry").value;
    }

}

export class PaymentDTO {
    isCardPayment: boolean;
    encryptedForm: any;
    amount: number;
    coupon: any;
    userAgent: any;
}